import { render, staticRenderFns } from "./STime.vue?vue&type=template&id=f70183cc"
import script from "./STime.vue?vue&type=script&lang=js"
export * from "./STime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports